import _ from 'lodash'
import FolderForm from 'scoreboard/components/folder-form'
import i18n from 'scoreboard/components/i18n'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import FormHelper from 'scoreboard/components/form-helper'
const { readFromDom } = FormHelper
import FormType from 'scoreboard/forms/model/form-type'
const { NAVIGATION_TABS } = FormType
import inputLengthValidatorFactory from 'scoreboard/components/validators/input-length-validator-factory'
import conductor from 'scoreboard/components/conductor'

const NavigationTabsForm = FolderForm.extend(/** @lends {NavigationTabsForm} */{

	/** @type {Form} */
	model: null,

	/**
	 * Form for editing form navigation tabs
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model the navigation tabs
	 */
	initialize: function(options = {}) {
		this.options = options
		this.tabs = viewEditTabs
		this.overviewTabCode = 'common.view'
		// #51483 add a length validator for the EditForm label field
		let labelLengthValidator = inputLengthValidatorFactory({
			high: 2000
		})
		this.options.validator = labelLengthValidator
		FolderForm.prototype.initialize.apply(this, arguments)

		if (this.model.isNew()) {
			this.model.set('label', i18n.get('forms.navigation-tabs'))
		}

		this.on('save', e => conductor.navigate(`forms/${e.id}/edit`))
	},

	render: function() {
		FolderForm.prototype.render.apply(this, arguments)

		// set the banner text
		let bannerText = i18n.get('forms.navigation-tabs.banner')
		this.$('.scroll-container').prepend(
			`<div class="banner">${bannerText}</div>`)

		// when creating new nav tabs, change the heading to "Create
		// Navigation Tabs"
		if (this.model.isNew()) {
			let headingText = i18n.get('common.new2',
				'forms.navigation-tabs')
			this.$('h1').text(headingText)
		}

		this.disableMoveCopy()

		// view tab should point to the overall form
		let href = `forms/${this.model.get('rootFormId')}`
		this.$('.overview-tab a').attr('href', href)

		// Pre-select the label field so users can start typing right away
		this.$('[name=label]').select()

		return this
	},

	getSubmitData: function() {
		return _.extend({}, this.model.attributes,
			readFromDom(this.el))
	},

	_getChangeObject: function() {
		return _.extend({ type: NAVIGATION_TABS }, this.getSubmitData())
	},

	cancel: function() {
		FolderForm.prototype.cancel.apply(this, arguments)
		this.disableMoveCopy()
	},

	/**
	 * Disables move/copy buttons to keep things simple
	 */
	disableMoveCopy: function() {
		this.$('.move-copy').addClass('is-not-displayed')
	}

})

export default NavigationTabsForm

NavigationTabsForm.__filename__ = 'forms/edit/navigation-tabs-form.js'
